// import React from 'react';
// import Select from 'react-select';

// import ReportConst from '../../util/ReportConst';

// import '../settings/Settings.css';
// import Const from '../../util/Constants';

// class ReportUpdateType extends React.Component {
  
//   render() {
//     const x = this.props.x;
//     const y = this.props.y;
//     const xFields = this.props.xFields;
//     const yFields = this.props.yFields;
//     const value = this.props.value;

//     const xField = xFields ? xFields.find(field => field.value === x) : null;
//     const yField = yFields ? yFields.find(field => field.value === y) : null;

//     let options = [];
//     if(yField && !xField && yField.type.includes(Const.Select)) {
//       options = [ { label: "Single Select", value: ReportConst.Select } ];
//     } else if(xField && yField 
//       && xField.type.includes(Const.Select) && yField.type.includes(Const.Select)) {
//       options = [ { label: "Multi Select", value: ReportConst.SelectToSelect } ];
//     } else if(yField && yField.type.includes(Const.Date)) {
//       options = [
//         { label: "Hourly wise Report", value: ReportConst.SelectToHr },
//         { label: "Day wise Report", value: ReportConst.SelectToDay },
//         { label: "Month wise Report", value: ReportConst.SelectToMonth },
//         { label: "Complex Month wise Report", value: ReportConst.ComplexTimeToSelect }
//       ];
//     }

//     return (
//       <div className="col-md-4">
//         <div className="formhead col-md-12"><h4>Report Type</h4></div>
//         <div className="condition-select col-md-12">
//           <Select 
//             value={options.find(option => option.value === value)} 
//             className="mr-sm-2"
//             options={options}
//             onChange={field => this.props.onChange(field ? field.value : null)} 
//             isSearchable={true} isClearable={true} />
//         </div>
//       </div>
//     );
//   }
// }
// export default ReportUpdateType;





import React from 'react';
import Select from 'react-select';

import ReportConst from '../../util/ReportConst';

import '../settings/Settings.css';
//import Const from '../../util/Constants';

class ReportUpdateType extends React.Component {
  
  render() {
    const value = this.props.value;
       const options = [
      { label: 'Only Select or MultiSelect Field', value: ReportConst.Select },
      { label: '2 Select or MultiSelect Field', value: ReportConst.SelectToSelect },
      { label: 'Hourly Select or MultiSelect Field', value: ReportConst.SelectToHr },
      { label: 'Daily Select or MultiSelect Field', value: ReportConst.SelectToDay },
      { label: 'Monthly Select or MultiSelect Field', value: ReportConst.SelectToMonth },
      { label: 'Target Report', value: ReportConst.Target },
      { label: 'Consolidate Report', value: ReportConst.Consolidate },
      { label: 'Monthly Target Report', value: ReportConst.MonthlyTarget },
      { label: 'Complex Only Select or MultiSelect Field', value: ReportConst.ComplexSelect },
      { label: 'Complex 2 Select or MultiSelect Field', value: ReportConst.ComplexSelectToSelect }
    ];

    return (
      <div className="col-md-4">
        <div className="formhead col-md-12"><h4>Report Type</h4></div>
        <div className="condition-select col-md-12">
          <Select 
            value={options.find(option => option.value === value)} 
            className="mr-sm-2"
            options={options}
            onChange={field => this.props.onChange(field ? field.value : null)} 
            isSearchable={true} isClearable={true} />
        </div>
      </div>
    );
  }
}
export default ReportUpdateType;